"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescendantProfessions = exports.minTaxonomy = exports.taxonomy = void 0;
exports.taxonomy = require('./taxonomy.json');
exports.minTaxonomy = require('./taxonomy-min.json');
const getDescendantProfessions = (id) => {
    const children = exports.minTaxonomy[id];
    if (!children) {
        return [];
    }
    return [id, ...children.map((c) => (0, exports.getDescendantProfessions)(c))].flat();
};
exports.getDescendantProfessions = getDescendantProfessions;
